var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBellIcon = function SvgBellIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#404A5C",
    d: "M7.518 33.47v-4.128h2.023V19.146q0-4.002 2.464-7.12 2.464-3.117 6.383-4.002V6.128q0-1.088.763-1.85a2.53 2.53 0 0 1 1.854-.762 2.5 2.5 0 0 1 1.849.762q.758.762.758 1.85v1.896q3.917.885 6.404 3.973 2.485 3.088 2.485 7.15v10.195h2.022v4.129zm13.471 5.562a3.39 3.39 0 0 1-2.496-1.04 3.42 3.42 0 0 1-1.032-2.5h7.078q0 1.476-1.043 2.508a3.44 3.44 0 0 1-2.507 1.032m-7.32-9.69h14.703V19.146q0-3.075-2.151-5.203-2.153-2.127-5.225-2.127t-5.2 2.127q-2.127 2.128-2.127 5.203z"
  })));
};
export default SvgBellIcon;